import { ModalConfirmation } from '#components'

export const useModal = () => {
  const overlay = useOverlay()

  const open = async (
    component: Component,
    props?: Record<string, any>
  ): Promise<any> => {
    const modal = overlay.create(component, { props })
    const instance = modal.open()
    const result = await instance.result
    if (result && props?.onSubmit)
      return await props.onSubmit(result)
    return result
  }

  const confirm = async ({
    title,
    description,
    okClick,
    icon,
    body
  }: {
    title: string
    description: string
    icon?: string
    body?: string
    okClick?: () => Promise<any>
  }): Promise<boolean> => {
    const modal = overlay.create(ModalConfirmation, {
      props: { title, description, icon, body }
    })
    const instance = modal.open()
    const result = await instance.result

    if (result && okClick)
      return await okClick()
    return !!result
  }

  return { open, confirm }
}
